"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorEntryDailyActivityReportResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
class BehaviorEntryDailyActivityReportResponseDto extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (!options)
            return;
        Object.assign(this, options);
    }
    getFields() {
        return [
            'id',
            'studentInternalId',
            'studentId',
            'studentName',
            'grade',
            'entryDate',
            'entryTime',
            'behaviorCode',
            'notes',
            'reaction',
            'issuedBy'
        ];
    }
    id;
    studentInternalId;
    studentId;
    studentName;
    grade;
    entryDate;
    entryTime;
    behaviorCode;
    notes;
    reaction;
    reactionDate;
    complyDate;
    issuedBy;
}
exports.BehaviorEntryDailyActivityReportResponseDto = BehaviorEntryDailyActivityReportResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "studentInternalId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "studentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "studentName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "grade", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "entryDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "entryTime", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "behaviorCode", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "notes", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "reaction", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "reactionDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "complyDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BehaviorEntryDailyActivityReportResponseDto.prototype, "issuedBy", void 0);
